<template>
    <div class="main">
        <div class="wp4">
            <div class="page-tit dffs">
                <router-link class="back-btn" to="/userCenter/newUserIndex"></router-link>
                日程安排
            </div>
            <div class="user-tab dfjc">
                <a href="" class="g-btn_icon">
                    <div class="icon" style="width: 22px;height: 20px;">
                        <img src="@/assets/images/yuyue.svg" class="def" alt="">
                        <img src="@/assets/images/yuyue-y.svg" class="active" alt="">
                    </div>
                    <router-link to="/userCenter/industryGuest/guestBooking">
                        <span>前往预约</span>
                    </router-link>
                </a>
            </div>
            <div class="table-wrap">
                <table>
                    <thead>
                        <tr>
                            <th style="width: 20%">活动名称</th>
                            <th style="width: 20%">活动地点</th>
                            <th style="width: 20%">活动时间</th>
                            <th style="width: 20%">报名时间</th>
                            <th style="width: 20%">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in appointList" :key="index">
                            <td>
                                <span class="tag-span">{{ item.activityTypeName }}</span>
                                {{ item.activityName }}
                            </td>
                            <td>{{ item.activityAdress }}</td>
                            <td>
                                {{ item.activityStartTime | timeFilter('{y}/{m}/{d} {h}:{i}') }} - {{
                                    item.activityEndTime | timeFilter('{y}/{m}/{d} {h}:{i}') }}
                            </td>
                            <td>
                                {{ item.signStartTime | timeFilter('{y}/{m}/{d} {h}:{i}') }} - {{ item.signEndTime |
                                    timeFilter('{y}/{m}/{d} {h}:{i}') }}
                            </td>
                            <td>
                                <div class="btn theme" @click="cancelBtn(item)">取消预约</div>
                            </td>
                        </tr>
                        <tr v-if="appointList.length == 0">
                            <td class="text-gray" colspan="5">暂无数据</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
import { sessionData } from "@/static/js/local.js";
import { activityApi } from '@/api/industry';
let that;

export default {
    data() {
        return {
            userInfo: {},
            appointList: []
        }
    },
    filters: {
        timeFilter: function (tsp, type) {
            try {
                if (!tsp || tsp.toString().length == 0) {
                    return ''
                }

                return that.$parseTime(tsp, type)
            } catch (err) {
                return ''
            }
        },
    },
    beforeCreate() {
        that = this;
    },
    created() {
        this.userInfo = sessionData("get", "UserInfo");
        if (this.userInfo && this.userInfo.accountId) {
            this.getList();
        } else {
            this.$message.warning('请先登录');
            this.goBack();
        }
    },
    methods: {
        getList() {
            const loading = this.$Loading.service({
                target: '#table',
                text: "",
                customClass: "custom-loading",
            });
            activityApi.getSignList({
                mainId: this.$session.get("cmm").mainId,
                accountId: this.userInfo.accountId
            }).then(res => {
                this.appointList = res.data;
            }).finally(() => {
                setTimeout(() => {
                    loading.close();
                }, 500);
            })
        },
        cancelBtn(obj) {
            this.$msgbox({
                title: "确认信息",
                message: `确认取消预约“${obj.activityName}”`,
                showClose: false,
                showCancelButton: true,
                cancelButtonClass: "cancel-btn-color",
                confirmButtonClass: "btn-color",
                callback: (action, instance) => {
                    if (action == "confirm") {
                        activityApi.cancel(obj.activitySignId).then(res => {
                            this.$message.success('操作成功');
                            this.getList();
                        })
                    }
                }
            });
        },
        goBack() {
            this.$router.push("/userCenter/newUserIndex");
        },
        toPage() {
            this.$router.push({ name: 'activityAppoint' });
        }
    }
}
</script>

<style scoped>
.text-gray {
    text-align: center;
}

.td-btn {
    color: #cbad71;
    cursor: pointer;
}
</style>
